import { useCallback, useEffect, useState } from 'react';
import {
  loadTeamUpdateNotificationSettings,
  saveTeamUpdateNotificationSettings,
  TEAM_UPDATE_NOTIFICATION_SETTINGS_EVENT,
  type TeamUpdateNotificationSettings,
} from '../utilities/teamUpdateNotificationSettings';

export function useTeamUpdateNotificationSettings() {
  const [settings, setSettings] = useState<TeamUpdateNotificationSettings>(() =>
    loadTeamUpdateNotificationSettings()
  );

  useEffect(() => {
    const refresh = () => setSettings(loadTeamUpdateNotificationSettings());
    window.addEventListener(TEAM_UPDATE_NOTIFICATION_SETTINGS_EVENT, refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener(TEAM_UPDATE_NOTIFICATION_SETTINGS_EVENT, refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const updateSettings = useCallback(
    (patch: Partial<TeamUpdateNotificationSettings>) => {
      const next = { ...loadTeamUpdateNotificationSettings(), ...patch };
      if (patch.mutedGroupIds) {
        next.mutedGroupIds = [...new Set(patch.mutedGroupIds.filter(Boolean))];
      }
      saveTeamUpdateNotificationSettings(next);
      setSettings(next);
    },
    []
  );

  return { settings, updateSettings };
}
